import React, { useEffect, useState } from "react";
import styles from "./Tile.module.css";
import { useSelector, useDispatch } from "react-redux";
import sun from "../../images/sun.webp";
import alien from "../../images/alien.webp";
import alienWitePurpleEyes from "../../images/alienWitePurpleEyes.webp";
import {
  beforePlay,
  duringPlay,
  lostGame,
  inPlay,
  wonGame,
} from "../../redux/types/userModeTypes";
import AnimatedAlienImage from "./AnimatedAlienImage/AnimatedAlienImage";
import useCellSelect from "../../utils/useCellSelect";
import clickAudio from "../../audios/click.mp3";
import useSound from "use-sound";
import getSoundEffectVolume from "../../utils/getSoundEffectVolume";
import { changeSelectedTile } from "../../redux/slices/gameSettingsSlice";
const _win = "win";
const _default = "default";
const _lose = "lose";

const Tile = ({ index }) => {
  const sounds = useSelector((state) => state.sounds);
  const [status, setStatus] = useState(_default);
  const [onClickEffect, setOnClickEffect] = useState(false);
  const [isBlur, setIsBlur] = useState(false);
  const [lostImage, setLostImage] = useState(alien);
  const userMode = useSelector((state) => state.userMode);
  const finishedTilesArray = useSelector((state) => state.finishedTilesArray);
  const gameData = useSelector((state) => state.gameData);
  const gameSettings = useSelector((state) => state.gameSettings);
  const selectCell = useCellSelect();
  const dispatch = useDispatch();

  const [playClickSound] = useSound(clickAudio, {
    volume: getSoundEffectVolume(),
    soundEnabled: !sounds.isSoundEffectsMute,
  });
  const clickSound = () => {
    playClickSound();
  };
  useEffect(() => {
    if (userMode.matchState === lostGame) {
      if (status === _default && onClickEffect === false) {
        if (finishedTilesArray.array.length > 0) {
          setStatus(finishedTilesArray.array[index]);
        }
        setIsBlur(true);
      }
      setTimeout(() => {
        setLostImage(alienWitePurpleEyes);
      }, [200]);
    }
    if (userMode.matchState === inPlay) {
      setIsBlur(false);
      setOnClickEffect(false);
      setStatus(_default);
      setLostImage(alien);
    }
    if (userMode.matchState === wonGame) {
      if (status === _default && onClickEffect === false) {
        if (finishedTilesArray.array.length > 0) {
          setStatus(finishedTilesArray.array[index]);
        }
        setIsBlur(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userMode.matchState]);
  useEffect(() => {
    if (
      userMode.matchState === inPlay &&
      gameData.openedIndexes !== undefined
    ) {
      if (gameData.openedIndexes.includes(index)) {
        setStatus(_win);
        setOnClickEffect(false);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameData]);

  const callSelectCell = async () => {
    const res = await selectCell(index);
    setStatus(res);
    setOnClickEffect(false);
  };

  const handleClick = async (e) => {
    if (
      !gameSettings.isInManualMode &&
      userMode.userModeState === beforePlay &&
      status === _default &&
      isBlur === false
    ) {
      dispatch(changeSelectedTile(index));
    }
    if (
      userMode.userModeState !== beforePlay &&
      status === _default &&
      isBlur === false &&
      gameSettings.isInManualMode
    ) {
      clickSound();
      setOnClickEffect(true);
      callSelectCell();
    }
  };

  return (
    <div
      className={`${
        userMode.userModeState === beforePlay || isBlur === false
          ? styles.baseTileNoClickable
          : styles.baseTile
      }  ${styles[status]} ${
        userMode.userModeState === duringPlay &&
        status === _default &&
        isBlur === false
          ? styles.hoverEffect
          : ""
      } ${onClickEffect ? styles.tilePress : ""} ${
        isBlur ? styles.blur : ""
      }  ${
        gameSettings.selectedTiles.includes(index) &&
        !gameSettings.isInManualMode
          ? styles.tilePress
          : styles.default
      }`}
      onClick={handleClick}
    >
      {status === _win ? (
        <img alt="sun" src={sun} className={`${styles.sunImage}`} />
      ) : (
        <div />
      )}
      {status === _lose ? (
        // <animated.div
        //   key={"alien"}
        //   class="bg"
        //   style={{ ...props, backgroundImage: lostImage }}
        // />
        <AnimatedAlienImage
          imageSrc={lostImage}
          isPurple={lostImage === alienWitePurpleEyes}
        />
      ) : (
        // <img alt="alien" src={lostImage} className={`${styles.alienImage}`} />
        <div />
      )}
    </div>
  );
};

export default Tile;
